import React from 'react'
import '../../styles/AdvisorsPartnersTeamStyles/advisorindividual.css'
import '../../styles/AdvisorsPartnersTeamStyles/teamindividual.css'

import linkedin from './../../resources/AdvisorsPartnersTeamResources/linkedin.svg'
export default class AdvisorIndividual extends React.Component{
    render(){
        return(
            <section className="ai__container">
                <img className="ai__img" src={this.props.img} />
                <div className="ai__overlay">
                    <div className="ai__information">
                        <div className='ai__name'>
                            {this.props.firstName} {this.props.lastName}
                        </div>
                        <div className='ai__role'>
                            {this.props.role}
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/AdvisorsPartnersTeam/AdvisorIndividual.js